import Recents from '../../../assets/recent.svg';

const RecentIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Recents {...props} />;
};

export default RecentIcon;
